<template>
  <div>
    <el-dialog :title="$t('user64')" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="isShowDialog" class="info-dialog">
      <div class="data-authentication">

        <div class="box">

          <el-form :model="formData" ref="formData" class="reset-from">

            <el-form-item prop="phone" label="开户人：">
              <template slot="label">
                <I18Lang id="user61" defaultText="开户人" />
              </template>
              <el-input class="reset-input" :placeholder="$t('user66')" v-model="formData.bank_user"></el-input>
            </el-form-item>

            <el-form-item prop="phone" label="银行名称：">
              <template slot="label">
                <I18Lang id="user62" defaultText="银行名称" />
              </template>
              <el-input class="reset-input" :placeholder="$t('user67')" v-model.trim="formData.bank_name"></el-input>
            </el-form-item>

            <el-form-item prop="phone" label="银行卡号：">
              <template slot="label">
                <I18Lang id="user63" defaultText="卡号" />
              </template>
              <el-input class="reset-input" :placeholder="$t('user68')" v-model.trim="formData.bank_no"></el-input>
            </el-form-item>

            <div class="bank-card">
              <Upload @fileChange="frontIDCard" file_directory="auth">
                <div class="upload-view">
                  <img class="img" v-if="formData.id_pic_a_url" :src="formData.id_pic_a_url" alt="" />
                  <img v-else class="upload-img" src="@/assets/img/user/upload-img.png" alt="" />
                </div>
              </Upload>
            </div>

          </el-form>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <div class="kg-btn2" @click="showInfoSupplement = false">
          <I18Lang id="my58" defaultText="取消" />
        </div>

        <div class="kg-btn2" type="primary" @click="submitData">
          <I18Lang id="my25" defaultText="确定" />
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import Upload from '@/components/Upload/Upload.vue'
import { fileDomain } from '@utils'
import { mapState } from 'vuex'
export default {
  name: 'home',
  data () {
    return {
      fileDomain,
      isShowDialog: false,
      isLoadingInfo: false,
      formData: {
        bank_name: '',
        bank_no: '',
        bank_user: '',
        swift_code: '',
        id_pic_a_url: '',
        id_pic_b_url: ''
      }
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    showDialog () {
      this.isShowDialog = true
    },
    frontIDCard (file) { // 身份证正面
      this.formData.id_pic_a_url = file
    },
    reverseIDCard (file) { // 身份证正面
      this.formData.id_pic_b_url = file
    },
    submitData () {
      if (!this.formData.bank_no) {
        this.$alert(this.$t('user68'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'warning-alert',
          callback: action => {
          }
        })
        return false
      }
      this.$http.post('/api/user/editBankInfo', this.formData).then(result => {
        this.$alert(this.$t('public62'), {
          confirmButtonText: this.$t('my25'),
          center: true,
          customClass: 'success-alert',
          callback: action => {
            this.$emit('onUpdata')
            this.isShowDialog = false
          }
        })
      })
    }
  },
  components: {
    Upload
  }
}
</script>
<style scoped lang="scss">
::v-deep .info-dialog {
  .el-dialog {
    width: 646px !important;
    min-height: 500px;
    .el-dialog__header {
      .el-dialog__title {
        padding-top: 5px;
      }

      .el-dialog__headerbtn {
        margin-top: 8px;
      }
    }
  }
}

.data-authentication {
  display: flex;
  padding: 10px 85px 0 65px;
  justify-content: space-between;

  .box {
  }
  .upload-view {
    .upload-img{
      width: 110px;
      height: 110px;
    }
    .img {
      width: 110px;
      height: 110px;
      border: 1px solid rgba(1, 178, 245, 0.5);
    }
  }
}
</style>
